import { jsx as _jsx } from "react/jsx-runtime";
import Routes from "./routes";
import { AuthContextProvider } from './context/authContext';
import { TitleContextProvider } from "./context/titleContext";
function App() {
    return (_jsx(TitleContextProvider, { children: _jsx(AuthContextProvider, { children: _jsx(Routes, {}, void 0) }, void 0) }, void 0));
}
export default App;
